import { Dispatch, Action } from "redux";
import { loadAndTrack } from "redux-request-loading";
import { ThunkDispatch } from "redux-thunk";

import { AnsweredQuestionWithId } from "@teamprevent/common/questionnaires/model";
import {
    SUBMIT_QUESTIONNAIRE,
    submitQuestionnaireSuccess,
    submitInvalidQuestionnaire,
    clearQuestionnaire,
    questionnaireLoaded,
    saveQuestionnaireSuccess
} from "@teamprevent/common/questionnaires/actions";
import { navigateToParentRoute } from "@teamprevent/common/routing/actions";
import { toast } from "@teamprevent/common/toasts";
import { PHYSIOTHERAPY_MGR_REFERRAL_QUESTIONNAIRE_KEY } from "@teamprevent/common/physiotherapy/models";

import { ApplicationState } from "../applicationState";
import { submitClinicalNotesSuccess } from "../clinicalNotes/actions";
import { questionnaireKey } from "../clinicalNotes/components/ClinicalNotes";

import { physiotherapyReferralApi } from "./physiotherapyReferralApi";
import { PhysiotherapyAssessmentConsultationKey } from "./models";
import { LOAD_UNMATCHED_PHYSIOTHERAPY_MGR_REFERRAL, SAVE_PHYSIOTHERAPY_ASSESSMENT_CONSULTATION_CLINICAL_NOTES } from "./actionTypes";

export const savePhysiotherapyAssessmentConsultationClinicalNotes = (
    ohCaseId: string,
    taskId: string,
    customerId: string,
    questions: AnsweredQuestionWithId[],
    eTag: string) => {
    return async (dispatch: ThunkDispatch<ApplicationState, undefined, Action>) => {
        const response = await loadAndTrack(
            dispatch,
            SAVE_PHYSIOTHERAPY_ASSESSMENT_CONSULTATION_CLINICAL_NOTES,
            physiotherapyReferralApi.saveClinicalNotes(customerId, ohCaseId, taskId, questions, eTag)
        );
        dispatch(saveQuestionnaireSuccess({ questionnaireKey, eTag: response.eTag }));
    };
};

export const submitPhysiotherapyAssessmentConsultationClinicalNotes = (
    ohCaseId: string, taskId: string, customerId: string, questions: AnsweredQuestionWithId[]
) => {
    if (!questions.every(question => question.isValid)) {
        return (dispatch: Dispatch) => dispatch(submitInvalidQuestionnaire(PhysiotherapyAssessmentConsultationKey));
    }
    return async (dispatch: ThunkDispatch<ApplicationState, undefined, Action>) => {
        const result = await loadAndTrack(
            dispatch,
            SUBMIT_QUESTIONNAIRE,
            physiotherapyReferralApi.submitClinicalNotes(customerId, ohCaseId, taskId)
        );
        toast.success("Clinical Notes submitted successfully");
        dispatch(submitQuestionnaireSuccess(PhysiotherapyAssessmentConsultationKey));
        dispatch(submitClinicalNotesSuccess({
            ohCaseId,
            tasks: result
        }));
        dispatch(navigateToParentRoute());
    };
};

export const loadUnmatchedPhysiotherapyReferralDetails = (customerId: string, physiotherapyReferralId: string) =>
    async (dispatch: Dispatch) => {
        dispatch(clearQuestionnaire(PHYSIOTHERAPY_MGR_REFERRAL_QUESTIONNAIRE_KEY));
        const result = await loadAndTrack(
            dispatch,
            LOAD_UNMATCHED_PHYSIOTHERAPY_MGR_REFERRAL,
            physiotherapyReferralApi.getUnmatched(customerId, physiotherapyReferralId)
        );
        dispatch(questionnaireLoaded({ questions: result.data.questions, questionnaireKey: PHYSIOTHERAPY_MGR_REFERRAL_QUESTIONNAIRE_KEY }));
    };
